import { AbstractRoomCommand } from './AbstractRoomCommand';
import { BasicElement, SceneElement } from '@egr/wcf/modules/core/mdl';
import { ElementChangedFlags } from '@egr/wcf/modules/core/mdl';
import { GroupElement } from './../mdl/GroupElement';
import { MainArticleElement } from '@egr/wcf/modules/cf';
export class ReplaceObjects extends AbstractRoomCommand {
    constructor(pRoomManager, pToReplace, pReplaceWith) {
        super(pRoomManager);
        this.mRoomManager = pRoomManager;
        this.mUndoData = {};
        this.mUndoData.ReplaceWith = pReplaceWith;
        //store elements
        this.mUndoData.toReplace = [];
        for (let tElement of pToReplace) {
            let tnewObject = {};
            tnewObject.originalElement = tElement;
            tnewObject.newElement = undefined;
            if (tElement.node.parent == null) {
                tnewObject.ParentGroup = null;
                this.mUndoData.toReplace.push(tnewObject);
                continue;
            }
            let tParentGroup = SceneElement.FromNode(tElement.node.parent, false);
            if (tParentGroup instanceof GroupElement) {
                tnewObject.ParentGroup = tParentGroup;
                this.mUndoData.toReplace.push(tnewObject);
            }
        }
    }
    isUndoable() {
        return (true);
    }
    isAvailable() {
        return (this.mUndoData.toReplace.length > 0);
    }
    cancel() {
        this.undo();
    }
    execute(pParameter) {
        this.replace();
        return (Promise.resolve(true));
    }
    undo() {
        this.replace_undo();
        return (Promise.resolve());
    }
    redo() {
        this.replace_redo();
        return (Promise.resolve());
    }
    dispose() {
        if (!this.mRoomManager.isClearing)
            return;
        for (let tObject of this.mUndoData.toReplace) {
            if (tObject.newElement != null)
                tObject.newElement.dispose();
            if (tObject.originalElement != null)
                tObject.originalElement.dispose();
        }
        this.mUndoData = null;
    }
    replace() {
        let tRes = new Array();
        let tselLength = this.mUndoData.toReplace.length;
        if (tselLength == 0) {
            return undefined;
        }
        let ttoSelect = new Array();
        for (let tObject of this.mUndoData.toReplace) {
            // ignore other elements than MainArticleElement, BasicElement (PEC)
            if ((tObject.originalElement == null) ||
                (!(tObject.originalElement instanceof MainArticleElement) &&
                    !(tObject.originalElement instanceof BasicElement))) {
                continue;
            }
            // switch between root elements and elements in groups
            if (tObject.ParentGroup == null) {
                this._replace_rootElements(tObject);
                if (tObject.newElement != null) {
                    this.mApp.model.removeElement(tObject.originalElement, true, false);
                    this.mApp.model.addElement(tObject.newElement, null, false);
                }
            }
            else {
                // elements in groups (GroupElement)
                this._replace_ElementsInGroups(tObject);
            }
        }
        this.mApp.model.notifyModification();
        this.setSelection(false);
        this.mApp.viewer.requestRenderFrame();
        return (tRes);
    }
    replace_undo() {
        if (this.mUndoData.toReplace.length == 0) {
            return undefined;
        }
        for (let tObject of this.mUndoData.toReplace) {
            if (tObject.ParentGroup == null) {
                this._replace_rootElements_undo(tObject);
            }
            else {
                this._replace_GroupElements_undo(tObject);
            }
        }
        this.mApp.model.notifyModification();
        this.setSelection(true);
        this.mApp.viewer.requestRenderFrame();
        return (this.mUndoData.toReplace);
    }
    replace_redo() {
        if (this.mUndoData.toReplace.length == 0) {
            return undefined;
        }
        for (let tObject of this.mUndoData.toReplace) {
            if (tObject.ParentGroup == null) {
                this._replace_rootElements_redo(tObject);
            }
            else {
                this._replace_GroupElements_redo(tObject);
            }
        }
        this.mApp.model.notifyModification();
        this.setSelection(false);
        this.mApp.viewer.requestRenderFrame();
        return (this.mUndoData.toReplace);
    }
    //// private /////////////////////////////////////////////////////////////////////////////
    setSelection(pSelectOriginal) {
        this.mApp.model.setSelection([]);
        for (let tObject of this.mUndoData.toReplace) {
            if (pSelectOriginal) {
                if (tObject.originalElement != null)
                    this.mApp.model.addToSelection(tObject.originalElement);
            }
            else if (tObject.newElement != null) {
                this.mApp.model.addToSelection(tObject.newElement);
            }
        }
    }
    _replace_rootElements(pObject) {
        if (pObject.originalElement == null)
            return;
        let tClone = this.mUndoData.ReplaceWith.clone();
        if (tClone != null) {
            pObject.newElement = tClone;
            let tWM_oriElement = pObject.originalElement.node.computeWorldMatrix();
            let tbb = pObject.originalElement.boundingBoxVisible.getCenter();
            let tbb_new = tClone.boundingBoxVisible.getCenter();
            let ttransDiff = tbb.subtract(tbb_new);
            tWM_oriElement = tWM_oriElement.addTranslationFromFloats(ttransDiff.x, 0, ttransDiff.z);
            tClone.setTransform(tWM_oriElement);
            tClone.updateTransformation();
        }
    }
    _replace_ElementsInGroups(pObject) {
        if (pObject.originalElement == null || pObject.originalElement.node == null || pObject.ParentGroup == null)
            return;
        let tClone = this.mUndoData.ReplaceWith.clone();
        if (tClone == null)
            return;
        pObject.newElement = tClone;
        let toriLocalMatrix = pObject.originalElement.node._localMatrix.clone();
        // translate to center of visible boundingbox
        let tbb = pObject.originalElement.boundingBoxVisible.getCenter();
        let tbb_new = pObject.newElement.boundingBoxVisible.getCenter();
        let ttransDiff = tbb.subtract(tbb_new);
        toriLocalMatrix = toriLocalMatrix.addTranslationFromFloats(ttransDiff.x, 0, ttransDiff.z);
        pObject.newElement.setTransform(toriLocalMatrix);
        this.mApp.model.removeElement(pObject.newElement, false, false);
        this.mApp.model.addElement(pObject.newElement, pObject.ParentGroup.node);
        pObject.ParentGroup.addElement(pObject.newElement);
        pObject.ParentGroup.removeElement(pObject.originalElement);
        this.mApp.model.removeElement(pObject.originalElement, true, false);
        pObject.newElement.getMainElement = () => pObject.ParentGroup;
        pObject.newElement.notifyChange(ElementChangedFlags.Transformation);
        pObject.newElement.eventPropertiesChanged.addListener(pObject.ParentGroup.ElementPropertiesChanged(pObject.newElement));
        pObject.newElement.updateTransformation();
    }
    _replace_rootElements_undo(pObject) {
        if (pObject.originalElement == undefined || pObject.newElement == undefined)
            return;
        this.mApp.model.removeElement(pObject.newElement, true, false);
        this.mApp.model.addElement(pObject.originalElement, null, true);
        pObject.originalElement.updateTransformation();
    }
    _replace_GroupElements_undo(pObject) {
        if (pObject.originalElement == null ||
            pObject.ParentGroup == null ||
            pObject.newElement == null)
            return;
        // remove current element
        pObject.ParentGroup.removeElement(pObject.newElement);
        this.mApp.model.removeElement(pObject.newElement, true, false);
        // add original element
        this.mApp.model.removeElement(pObject.originalElement, false, false);
        this.mApp.model.addElement(pObject.originalElement, pObject.ParentGroup.node, true);
        pObject.ParentGroup.addElement(pObject.originalElement);
        pObject.originalElement.updateTransformation();
        pObject.ParentGroup.updateTransformation();
        pObject.ParentGroup.notifyChange(ElementChangedFlags.BoundingBox);
        pObject.ParentGroup.notifyChange(ElementChangedFlags.Transformation);
    }
    _replace_rootElements_redo(pObject) {
        if (pObject.originalElement == null || pObject.newElement == null)
            return;
        this.mApp.model.removeElement(pObject.originalElement, true, false);
        this.mApp.model.addElement(pObject.newElement, null, true);
        pObject.newElement.updateTransformation();
    }
    _replace_GroupElements_redo(pObject) {
        if (pObject.originalElement == null || pObject.ParentGroup == null || pObject.newElement == null)
            return;
        // remove original element
        pObject.ParentGroup.removeElement(pObject.originalElement);
        this.mApp.model.removeElement(pObject.originalElement, true, false);
        // add replaced element
        this.mApp.model.removeElement(pObject.newElement, false, false);
        this.mApp.model.addElement(pObject.newElement, pObject.ParentGroup.node, true);
        pObject.ParentGroup.addElement(pObject.newElement);
        pObject.newElement.updateTransformation();
        pObject.ParentGroup.updateTransformation();
        pObject.ParentGroup.notifyChange(ElementChangedFlags.BoundingBox);
        pObject.ParentGroup.notifyChange(ElementChangedFlags.Transformation);
    }
}
